module.exports = __webpack_public_path__ + "saira-light-webfont.6732ae22acc7771c690b.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-light-webfont.ttf
// module id = ../../../../../src/assets/fonts/saira-light-webfont.ttf
// module chunks = styles